import { useId } from 'react';
import { useTheme } from '@mui/material/styles';
import { getDiagramColors } from 'theme/canvasColors';
import { useResolvedColorScheme } from 'theme/colorSchemeStore';

const WIDTH = 240;
const HEIGHT = 127;
const GRID_SIZE = 10;

const gridLines = [
  ...Array.from({ length: WIDTH / GRID_SIZE }, (_, i) => (
    <line
      key={`v${i}`}
      x1={i * GRID_SIZE}
      y1={0}
      x2={i * GRID_SIZE}
      y2={HEIGHT}
    />
  )),
  ...Array.from({ length: Math.ceil(HEIGHT / GRID_SIZE) }, (_, i) => (
    <line
      key={`h${i}`}
      x1={0}
      y1={i * GRID_SIZE}
      x2={WIDTH}
      y2={i * GRID_SIZE}
    />
  )),
];

const FlowsheetPlaceholder = () => {
  const theme = useTheme();
  const scheme = useResolvedColorScheme();
  const canvas = getDiagramColors(scheme);
  const arrowId = useId();
  const link = theme.palette.info.main;

  return (
    <svg
      data-testid='flowsheet-placeholder'
      width='100%'
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio='xMidYMid slice'
      aria-hidden
      style={{ display: 'block' }}
    >
      <defs>
        <marker
          id={arrowId}
          viewBox='0 0 6 6'
          refX={5}
          refY={3}
          markerWidth={6}
          markerHeight={6}
          orient='auto'
        >
          <path d='M0,0 L6,3 L0,6 z' fill={link} />
        </marker>
      </defs>
      <rect width={WIDTH} height={HEIGHT} fill={canvas.background} />
      <g stroke={canvas.gridLine} strokeWidth={0.5}>
        {gridLines}
      </g>

      <g transform='translate(0 13) scale(0.8)'>
        <g
          fill='none'
          stroke={link}
          strokeWidth={2}
          markerEnd={`url(#${arrowId})`}
          opacity={0.7}
        >
          <path d='M62,48 H86' />
          <path d='M130,48 H160' />
          <path d='M216,40 H236 V30 H246' />
          <path d='M216,58 H236 V88 H246' />
        </g>

        <g
          fill={canvas.placeholderFill}
          stroke={canvas.placeholderStroke}
          strokeWidth={1.5}
        >
          <path d='M20,30 H60 L50,60 H30 Z' />
          <rect x={28} y={60} width={24} height={6} rx={1} />
          <rect x={88} y={26} width={40} height={48} rx={3} />
          <path d='M96,34 L108,58 L120,34' fill='none' />
          <path d='M162,30 L214,40 V70 L162,60 Z' />
          <path d='M168,42 L208,50 M168,52 L208,60' fill='none' />
          <path d='M248,44 L266,16 L284,44 Z' />
          <path d='M248,102 L266,74 L284,102 Z' />
        </g>
      </g>
    </svg>
  );
};

export default FlowsheetPlaceholder;
